export default "__VITE_ASSET__BhcP4BYc__"